import * as React from 'react';
import { UitkHeading } from 'uitk-react-text';
import { UitkSpacing } from 'uitk-react-spacing';
import { useStores } from 'utility/hooks';

export const PageTitleLoaded = () => {
  const { pageTitleStore } = useStores();
  const { title } = pageTitleStore;
  const titleShortMessage = title?.shortMessage;

  return (
    <section role="region" aria-labelledby="fsr-page-title" data-test-id="title">
      <UitkSpacing margin={{ blockend: 'six' }}>
        <div id="fsr-page-title" data-test-id="page-title-text">
          <UitkHeading level={1} size={600}>
            {titleShortMessage}
          </UitkHeading>
        </div>
      </UitkSpacing>
    </section>
  );
};
